module.exports = __webpack_public_path__ + "img/zanorari19.75cf69cb.jpg";